<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center d-flex justify-content-center align-items-center py_12" colspan="6">
            <div class="section-loading mr_6" style="height:20px; width:30px"></div>
            <h3 class="pre-formatted">{{content}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "mfLoading",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default:'資料讀取中，請稍候...'
    }
  },
  methods: {},
};
</script>
